/* eslint-disable max-len */
/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import utils, { TClaim, TJoin, TNonEmptyArray, TTenant, TUser, TUserClaim } from "../../helpers/utils.graphql";
import { CommandResult_UserClaim, CommandResult_Void } from "../../helpers/types.graphql";
import { CommandResult } from "../fragment.graphql";

export type TGlobal = TUserClaim
  | TJoin<"tenant", TTenant>
  | TJoin<"user", TUser>
  | TJoin<"claim", TClaim>

type TUserClaimCreateFunctions = { create: CommandResult_UserClaim };
export type TUserClaimCreateMutations = { userClaim: TUserClaimCreateFunctions };
export const userClaimCreate = (fields: TNonEmptyArray<TGlobal>) => gql`
  mutation userClaimCreate($userClaim: UserClaimCreateInputType!) {
    userClaim {
      create(userClaim: $userClaim) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_UserClaim")}
`;

type TUserClaimUpdateFunctions = { update: CommandResult_UserClaim };
export type TUserClaimUpdateMutations = { userClaim: TUserClaimUpdateFunctions };
export const userClaimUpdate = (fields: TNonEmptyArray<TGlobal>) => gql`
  mutation userClaimUpdate($userClaim: UserClaimUpdateInputType!) {
    userClaim {
      update(userClaim: $userClaim) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_UserClaim")}
`;

type TUserClaimDeleteFunctions = { delete: CommandResult_UserClaim };
export type TUserClaimDeleteMutations = { userClaim: TUserClaimDeleteFunctions };
export const userClaimDelete = () => gql`
  mutation userClaimDelete($id: Guid!, $permanent: Boolean) {
    userClaim {
      delete(id: $id, permanent: $permanent) {
        ...COMMAND_RESULT
      }
    }
  }
  ${CommandResult("CommandResult_Void")}
`;

type TSaveUserClaimsFunctions = { saveUserClaims: CommandResult_Void };
export type TSaveUserClaimsMutations = { userClaim: TSaveUserClaimsFunctions };
export const saveUserClaims = () => gql`
  mutation saveUserClaims($saveUserClaimsInput: SaveUserClaimsInput!) {
    userClaim {
      saveUserClaims (saveUserClaimsInput: $saveUserClaimsInput) {
        ...COMMAND_RESULT
      }
    }
  }
  ${CommandResult("CommandResult_Void")}
`;
